var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bim"},[(_vm.show)?_c('qmodel',{key:_vm.name,attrs:{"name":_vm.name}}):_vm._e(),_c('div',{staticClass:"bim-select"},[_c('data-select',{model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }